import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        author: 'fe01',
        seachKeyword:"", // 搜索框字段
        seachInfo: {}, // 搜索页码
    },
    getters: {
        authorName: function (state) {
            return state.author;
        },
    },
    mutations: {
        changeName: function (state, payload) {
            state.author = payload.author;
        },
        seachKeyword: function (state, payload) {
            console.log(state,payload)
            state.seachKeyword = payload;
            sessionStorage.setItem("seachKeyword",payload)
        },
        seachInfo: function (state, payload) {
            state.seachInfo = payload;
        },
    },
    actions: {
        actionChangeName: function (context, payload) {
            context.commit('changeName', payload);
        }
    }
})
